const FAQ = [
  {
    q: "How is this different from ngrok / Beeceptor / Mockoon?",
    a: "Those each do one thing well. Swisstools is the bundle: mocks, webhook inbox, feature flags, release notes — all scoped to the same project. Fewer tabs, one login, same URL pattern across all four tools.",
  },
  {
    q: "Is it actually free, or 'free trial' free?",
    a: "Actually free. No card on file, no caps on projects or mocks, no expiring trial. While we're in beta everything is free; paid plans only kick in for limits that real teams hit (think: usage above a generous monthly ceiling), and existing free usage stays free.",
  },
  {
    q: "Where does my webhook data live and for how long?",
    a: "Captured webhook requests sit in Redis for 12 hours, max 50 per inbox. They're never written to long-term storage. If you need them longer, replay them somewhere persistent — that's the whole replay button.",
  },
  {
    q: "Can I self-host?",
    a: "Not yet — the codebase is monolithic Bun + Postgres + Redis, so it's not far from feasible, but it's not packaged. If you have a strong reason to self-host, email and tell us why; that moves it up the list.",
  },
  {
    q: "What happens to my data if you shut down?",
    a: "You get a one-click JSON export of mocks, flags and release notes from the project page. We commit to 90 days' notice and a working export endpoint before anything goes dark. The dream is that this question stays hypothetical.",
  },
];

export function LandingFaq() {
  return (
    <section className="border-b border-rule">
      <div className="max-w-7xl mx-auto w-full px-5 sm:px-12 py-12 sm:py-16 grid lg:grid-cols-[280px_1fr] gap-10">
        <div>
          <span className="text-eyebrow text-signal-red">
            ∗ Things people ask
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-[-0.03em]">
            Honest{" "}
            <span className="font-serif italic font-normal">answers</span> to
            fair questions.
          </h2>
        </div>
        <dl className="divide-y divide-rule border-y border-rule">
          {FAQ.map((item) => (
            <div key={item.q} className="py-5">
              <dt className="font-serif text-lg font-semibold tracking-tight mb-2">
                {item.q}
              </dt>
              <dd className="text-sm leading-relaxed text-muted-foreground">
                {item.a}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
